<ng-template [ngIf]="test">

  <app-test-execution-start *ngIf="!currentExecution"
                            class="test-execution-start"
                            [urlCode]="urlCode"
                            [test]="test"
                            [unfinishedExecution]="unfinishedExecution"
                            [finishedExecution]="finishedExecution"
                            (startExecution)="onExecutionStart($event)"></app-test-execution-start>

  <app-questions-execution *ngIf="currentExecution && !expired && !currentExecution.finishDate"
                           class="test-execution-questions"
                           [urlCode]="urlCode"
                           [test]="test"
                           [testExecution]="currentExecution"
                           (finishExecution)="onExecutionFinish($event)"></app-questions-execution>

  <app-test-execution-finish *ngIf="currentExecution && !expired && currentExecution.finishDate"
                             class="test-execution-finish"
                             [testExecution]="currentExecution"
                             [testType]="test.type"></app-test-execution-finish>

  <app-test-execution-expired *ngIf="currentExecution && expired"
                              [testExecution]="currentExecution">
  </app-test-execution-expired>

</ng-template>

<div class="container" *ngIf="showErrorMessage">
  <div class="title">Данная ссылка устарела. Обратитесь в отдел кадров за новой ссылкой.</div>
</div>